export const Stripe = {
  getMonthlyId: async(payload = null) => {
    try {
      return new Promise((resolve, reject) => {
        let methodType = 'GET';
        let headers = {
            'content-type': 'application/json',
        };
        let body = null;
        if (payload){
            body = JSON.stringify(payload);
        }
        window
          .fetch(`https://srjy0azi23.execute-api.us-east-1.amazonaws.com/dev/monthly`, {
              body: body,
              cache: 'no-cache',
              headers: headers,
              method: `${methodType}`,
          })
          .then(async response => {
            if ((response.status >= 200) && (response.status <= 299)) {
                return response.json().then(resolve);
            } else {
                return reject(response);
            }
          })
          .catch(e => {
              reject(e);
          });
      });
    } catch (error) {
      return error;
    }
  },
  getYearlyId: async(payload = null) => {
    try {
      return new Promise((resolve, reject) => {
        let methodType = 'GET';
        let headers = {
            'content-type': 'application/json',
        };
        let body = null;
        if (payload){
            body = JSON.stringify(payload);
        }
        window
          .fetch(`https://srjy0azi23.execute-api.us-east-1.amazonaws.com/dev/yearly`, {
              body: body,
              cache: 'no-cache',
              headers: headers,
              method: `${methodType}`,
          })
          .then(async response => {
              if ((response.status >= 200) && (response.status <= 299)) {
                  return response.json().then(resolve);
              } else {
                  return reject(response);
              }
          })
          .catch(e => {
              reject(e);
          });
      });
    } catch (error) {
      return error;
    }
  },
  getCheckoutItems: async(payload = null, sessionId) => {
    try {
      return new Promise((resolve, reject) => {
        let methodType = 'GET';
        let headers = {
          'content-type': 'application/json',
        };
        let body = null;
        if (payload){
          body = JSON.stringify(payload);
        }
        window
          .fetch(`https://srjy0azi23.execute-api.us-east-1.amazonaws.com/dev/items/${sessionId}`, {
            body: body,
            cache: 'no-cache',
            headers: headers,
            method: `${methodType}`,
          })
          .then(async response => {
            if ((response.status >= 200) && (response.status <= 299)) {
              return response.json().then(resolve);
            } else {
              return reject(response);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    } catch (error) {
      return error;
    }
  },
  validateCoupon: async(payload = null, couponCode) => {
    try {
      return new Promise((resolve, reject) => {
        let methodType = 'GET';
        let headers = {
            'content-type': 'application/json',
        };
        let body = null;
        if (payload){
            body = JSON.stringify(payload);
        }
        window
          .fetch(`https://srjy0azi23.execute-api.us-east-1.amazonaws.com/dev/coupon/${couponCode}`, {
              body: body,
              cache: 'no-cache',
              headers: headers,
              method: `${methodType}`,
              mode: 'cors',
          })
          .then(async response => {
              if ((response.status >= 200) && (response.status <= 299)) {
                  return response.json().then(resolve);
              } else {
                  return reject(response);
              }
          })
          .catch(e => {
              reject(e);
          });
      });
    } catch (error) {
      return error;
    }
  },
  cancelSubscription: async(payload = null) => {
    try {
      return new Promise((resolve, reject) => {
        let methodType = 'POST';
        let headers = {
            'content-type': 'application/json',
        };
        let body = null;
        if (payload){
            body = JSON.stringify(payload);
        }
        window
          .fetch(`https://srjy0azi23.execute-api.us-east-1.amazonaws.com/dev/cancelSubscription`, {
              body: body,
              cache: 'no-cache',
              headers: headers,
              method: `${methodType}`,
              mode: 'no-cors',
          })
          .then(async response => {
              if ((response.status >= 200) && (response.status <= 299)) {
                  return response.json().then(resolve);
              } else {
                  return reject(response);
              }
          })
          .catch(e => {
              reject(e);
          });
      });
    } catch (error) {
      return error;
    }
  },
};
